import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, AppointmentType } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteAppointmentType {
  search?: string;
}

function useAutoCompleteAppointmentType({
  search,
}: IUseAutoCompleteAppointmentType): UseQueryResult<{ data: Array<AppointmentType> }> {
  const fetchAutoCompleteAppointmentType = (): Promise<AxiosResponse<{ data: Array<AppointmentType> }>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`appointment-types/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['appointmentType', search], fetchAutoCompleteAppointmentType);
}

export default useAutoCompleteAppointmentType;
